import React, { useEffect } from 'react';
import SummerHero from '../Sections/SummerHero';
import SummerPrograms from '../Sections/SummerPrograms';
import SummerTransformation from '../Sections/SummerTransformation';
import SummerMethodology from '../Sections/SummerMethodology';
import SummerSkills from '../Sections/SummerSkills';
import SummerContact from '../Sections/SummerContact';
import RegistrationModal from '../UI/RegistrationModal';

const SummerCampLanding = ({ isModalOpen, toggleModal }) => {

  // Automatic registration popup after 20 seconds
  useEffect(() => {
    // We only set the timer once when the component mounts
    const timer = setTimeout(() => {
      // We check the LATEST state. 
      // If it's already open (user clicked manually), we do nothing.
      // If it's closed, we nudge them.
      toggleModal(); 
    }, 25000); 

    return () => clearTimeout(timer);
    
    // LEAVE THIS ARRAY EMPTY []
    // An empty array means "Only run this code once when the page loads"
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="summer-camp-landing">
      {/* Section 1: Hero with Legacy Stats */}
      <SummerHero />

      {/* Section 2: Catalog with 5 Tracks */}
      <SummerPrograms onRegisterClick={toggleModal} />

      {/* Section 3 */}
      <SummerTransformation />

      {/* Section 4 */}
      <SummerMethodology />

      {/* Section 5 */}
      <SummerSkills onRegisterClick={toggleModal} />

      {/* Section 6: Contact Section */}
      <SummerContact />

      {/* Global Registration Modal (Logic for later) */}
      {/* {isModalOpen && (
        <div className="modal-overlay" onClick={toggleModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
             <div className="modal-header">
                <h3>Register for Summer Camp 2026</h3>
                <button className="close-btn" onClick={toggleModal}>&times;</button>
             </div>
             <form className="modal-form">
                <input type="text" placeholder="Student Name" required />
                <input type="tel" placeholder="Mobile Number" required />
                <select required>
                    <option value="">Select Program</option>
                    <option>Advanced Foundation</option>
                    <option>Basic Foundation</option>
                    <option>Intermediate IIT-Foundation</option>
                    <option>10th Class Bridge</option>
                    <option>Skill Oriented Courses</option>
                </select>
                <button type="submit" className="btn-submit-modal">Complete Registration</button>
             </form>
          </div>
        </div>
      )} */}
      <RegistrationModal isOpen={isModalOpen} onClose={toggleModal} />
    </div>
  );
};

export default SummerCampLanding;